import AppResource from './AppResource'

const BaseConfig = {
  localhost: {
    logo: AppResource.branding.vietinvoice_logo,
    secondLogo: AppResource.images.img_ICORP_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.vietinvoice_ico,
    },
    name: 'VIETINVOICE',
    menubar: [
      {
        translateText: 'Introduction',
        link: 'https://vietinvoice.vn/gioi-thieu',
      },
      {
        translateText: 'Price list',
        link: 'https://vietinvoice.vn/bang-gia',
      },
      {
        translateText: 'Invoice template',
        link: 'https://vietinvoice.vn/mau-hoa-don',
      },
      {
        translateText: 'Document',
        link: 'https://vietinvoice.vn/van-ban',
      },
      {
        translateText: 'Customer',
        link: 'https://vietinvoice.vn/khach-hang',
      },
      {
        translateText: 'News',
        link: 'https://vietinvoice.vn/tin-tuc',
      },
      {
        translateText: 'Contact',
        link: 'https://vietinvoice.vn/lien-he',
      },
    ],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.4751', value: '19004751' },
      { label: '0208.3607.668', value: '02083607668' },
    ],
    footer: {
      isHadFooter: true,
      content: {
        companyName: 'CÔNG TY CỔ PHẦN ICORP',
        address:
          'Tầng 3, số 112, phố Dịch Vọng Hậu, phường Dịch Vọng Hậu, quận Cầu Giấy TP Hà Nội',
        hotline: '1900.0099',
      },
    },
  },
  'hoadondientu.vietinvoice.vn': {
    logo: AppResource.branding.vietinvoice_logo,
    secondLogo: AppResource.images.img_ICORP_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.vietinvoice_ico,
    },
    name: 'VIETINVOICE',
    menubar: [
      {
        translateText: 'Introduction',
        link: 'https://vietinvoice.vn/gioi-thieu',
      },
      {
        translateText: 'Price list',
        link: 'https://vietinvoice.vn/bang-gia',
      },
      {
        translateText: 'Invoice template',
        link: 'https://vietinvoice.vn/mau-hoa-don',
      },
      {
        translateText: 'Document',
        link: 'https://vietinvoice.vn/van-ban',
      },
      {
        translateText: 'Customer',
        link: 'https://vietinvoice.vn/khach-hang',
      },
      {
        translateText: 'News',
        link: 'https://vietinvoice.vn/tin-tuc',
      },
      {
        translateText: 'Contact',
        link: 'https://vietinvoice.vn/lien-he',
      },
    ],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.0099', value: '19000099' },
      { label: '0988.399.516', value: '0988399516' },
    ],
    footer: {
      isHadFooter: true,
      content: {
        companyName: 'CÔNG TY CỔ PHẦN ICORP',
        address:
          'Tầng 3, số 112, phố Dịch Vọng Hậu, phường Dịch Vọng Hậu, quận Cầu Giấy TP Hà Nội',
        hotline: '1900.0099',
      },
    },
  },
  'tuluc.vietinvoice.vn': {
    logo: AppResource.branding.tuluc_ico,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.tuluc_ico,
    },
    name: 'TỰ LỰC',
    menubar: [],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử an toàn và thông minh',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.0099', value: '19000099' },
      { label: '0988.399.516', value: '0988399516' },
    ],
  },
  'seen.vietinvoice.vn': {
    logo: AppResource.branding.seen_logo,
    favicons: {
      rel: 'icon',
      type: 'image/x-icon',
      href: AppResource.branding.seen_logo,
    },
    name: 'SEEN',
    menubar: [],
    introduceText: {
      title: 'Giải pháp hóa đơn điện tử seen',
      content:
        'Trải nghiệm sử dụng hóa đơn theo cách hoàn toàn mới. Chúng tôi tin tưởng bạn sẽ đạt được nhiều hơn những gì mong đợi. Hãy bắt đầu trải nghiệm ngay',
    },
    serviceCustomerPhone: [
      { label: '1900.0099', value: '19000099' },
      { label: '0988.399.516', value: '0988399516' },
    ],
  },
}
export default BaseConfig
